// extracted by mini-css-extract-plugin
export default {"previewImage":"InfoPanel_previewImage__ZQz2U","previewImageContainer":"InfoPanel_previewImageContainer__3xpit"};